/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type NotificationRulesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type NotificationRulesQuery = { __typename: 'Query', notificationChannelTopics?: { __typename: 'NotificationChannelTopicTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'NotificationChannelTopicTypeEdge', node?: { __typename: 'NotificationChannelTopicType', id: string, name: string, createdAt: string, applicationReviewStates: Array<string>, notificationChannel?: { __typename: 'NotificationChannelType', id: string, channelType: Types.TenantedNotificationChannelChannelTypeChoices, isEnabled: boolean } | null, types?: Array<{ __typename: 'NotificationChannelTopicEventType', id: string, notificationType?: Types.NotificationEnum | null } | null> | null, clients?: Array<{ __typename: 'NotificationChannelTopicClientType', id: string, client?: { __typename: 'ClientType', id: string, name: string } | null } | null> | null, emailRecipients?: Array<{ __typename: 'NotificationChannelEmailRecipientType', id: string, emailAddress: string } | null> | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type NotificationChannelTopicQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type NotificationChannelTopicQuery = { __typename: 'Query', notificationChannelTopic?: { __typename: 'NotificationChannelTopicType', id: string, name: string, applicationReviewStates: Array<string>, notificationChannel?: { __typename: 'NotificationChannelType', id: string, channelType: Types.TenantedNotificationChannelChannelTypeChoices, isEnabled: boolean } | null, types?: Array<{ __typename: 'NotificationChannelTopicEventType', id: string, notificationType?: Types.NotificationEnum | null } | null> | null, clients?: Array<{ __typename: 'NotificationChannelTopicClientType', id: string, client?: { __typename: 'ClientType', id: string, name: string } | null } | null> | null, emailRecipients?: Array<{ __typename: 'NotificationChannelEmailRecipientType', id: string, emailAddress: string } | null> | null } | null };

export type CreateNotificationChannelTopicMutationVariables = Types.Exact<{
  input: Types.CreateNotificationChannelTopicMutationInput;
}>;


export type CreateNotificationChannelTopicMutation = { __typename: 'Mutation', createNotificationChannelTopic?: { __typename: 'CreateNotificationChannelTopicMutation', notificationChannelTopic?: { __typename: 'NotificationChannelTopicType', id: string } | null, errors?: Array<{ __typename: 'ErrorType', message?: string | null } | null> | null } | null };

export type UpdateNotificationChannelTopicMutationVariables = Types.Exact<{
  input: Types.UpdateNotificationChannelTopicMutationInput;
}>;


export type UpdateNotificationChannelTopicMutation = { __typename: 'Mutation', updateNotificationChannelTopic?: { __typename: 'UpdateNotificationChannelTopicMutation', notificationChannelTopic?: { __typename: 'NotificationChannelTopicType', id: string } | null, errors?: Array<{ __typename: 'ErrorType', message?: string | null } | null> | null } | null };

export type DeleteNotificationChannelTopicMutationVariables = Types.Exact<{
  input: Types.DeleteNotificationChannelTopicMutationInput;
}>;


export type DeleteNotificationChannelTopicMutation = { __typename: 'Mutation', deleteNotificationChannelTopic?: { __typename: 'DeleteNotificationChannelTopicMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', message?: string | null } | null> | null } | null };

export type SendTestNotificationMutationVariables = Types.Exact<{
  input: Types.SendTestNotificationMutationInput;
}>;


export type SendTestNotificationMutation = { __typename: 'Mutation', sendTestNotification?: { __typename: 'SendTestNotificationMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', message?: string | null } | null> | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const NotificationRulesDocument = new TypedDocumentString(`
    query NotificationRules($first: Int, $after: String) {
  notificationChannelTopics(first: $first, after: $after) {
    edges {
      node {
        id
        name
        createdAt
        applicationReviewStates
        notificationChannel {
          id
          channelType
          isEnabled
        }
        types {
          id
          notificationType
        }
        clients {
          id
          client {
            id
            name
          }
        }
        emailRecipients {
          id
          emailAddress
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `);

export const useNotificationRulesQuery = <
      TData = NotificationRulesQuery,
      TError = unknown
    >(
      variables?: NotificationRulesQueryVariables,
      options?: Omit<UseQueryOptions<NotificationRulesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationRulesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationRulesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['NotificationRules'] : ['NotificationRules', variables],
    queryFn: fetcher<NotificationRulesQuery, NotificationRulesQueryVariables>(NotificationRulesDocument, variables),
    ...options
  }
    )};

useNotificationRulesQuery.getKey = (variables?: NotificationRulesQueryVariables) => variables === undefined ? ['NotificationRules'] : ['NotificationRules', variables];

export const useInfiniteNotificationRulesQuery = <
      TData = InfiniteData<NotificationRulesQuery>,
      TError = unknown
    >(
      variables: NotificationRulesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationRulesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationRulesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NotificationRulesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['NotificationRules.infinite'] : ['NotificationRules.infinite', variables],
      queryFn: (metaData) => fetcher<NotificationRulesQuery, NotificationRulesQueryVariables>(NotificationRulesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationRulesQuery.getKey = (variables?: NotificationRulesQueryVariables) => variables === undefined ? ['NotificationRules.infinite'] : ['NotificationRules.infinite', variables];


useNotificationRulesQuery.fetcher = (variables?: NotificationRulesQueryVariables) => fetcher<NotificationRulesQuery, NotificationRulesQueryVariables>(NotificationRulesDocument, variables);

export const NotificationChannelTopicDocument = new TypedDocumentString(`
    query NotificationChannelTopic($id: UUID!) {
  notificationChannelTopic(id: $id) {
    id
    name
    applicationReviewStates
    notificationChannel {
      id
      channelType
      isEnabled
    }
    types {
      id
      notificationType
    }
    clients {
      id
      client {
        id
        name
      }
    }
    emailRecipients {
      id
      emailAddress
    }
  }
}
    `);

export const useNotificationChannelTopicQuery = <
      TData = NotificationChannelTopicQuery,
      TError = unknown
    >(
      variables: NotificationChannelTopicQueryVariables,
      options?: Omit<UseQueryOptions<NotificationChannelTopicQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationChannelTopicQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationChannelTopicQuery, TError, TData>(
      {
    queryKey: ['NotificationChannelTopic', variables],
    queryFn: fetcher<NotificationChannelTopicQuery, NotificationChannelTopicQueryVariables>(NotificationChannelTopicDocument, variables),
    ...options
  }
    )};

useNotificationChannelTopicQuery.getKey = (variables: NotificationChannelTopicQueryVariables) => ['NotificationChannelTopic', variables];

export const useInfiniteNotificationChannelTopicQuery = <
      TData = InfiniteData<NotificationChannelTopicQuery>,
      TError = unknown
    >(
      variables: NotificationChannelTopicQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationChannelTopicQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationChannelTopicQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NotificationChannelTopicQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NotificationChannelTopic.infinite', variables],
      queryFn: (metaData) => fetcher<NotificationChannelTopicQuery, NotificationChannelTopicQueryVariables>(NotificationChannelTopicDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationChannelTopicQuery.getKey = (variables: NotificationChannelTopicQueryVariables) => ['NotificationChannelTopic.infinite', variables];


useNotificationChannelTopicQuery.fetcher = (variables: NotificationChannelTopicQueryVariables) => fetcher<NotificationChannelTopicQuery, NotificationChannelTopicQueryVariables>(NotificationChannelTopicDocument, variables);

export const CreateNotificationChannelTopicDocument = new TypedDocumentString(`
    mutation CreateNotificationChannelTopic($input: CreateNotificationChannelTopicMutationInput!) {
  createNotificationChannelTopic(input: $input) {
    notificationChannelTopic {
      id
    }
    errors {
      message
    }
  }
}
    `);

export const useCreateNotificationChannelTopicMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateNotificationChannelTopicMutation, TError, CreateNotificationChannelTopicMutationVariables, TContext>) => {
    
    return useMutation<CreateNotificationChannelTopicMutation, TError, CreateNotificationChannelTopicMutationVariables, TContext>(
      {
    mutationKey: ['CreateNotificationChannelTopic'],
    mutationFn: (variables?: CreateNotificationChannelTopicMutationVariables) => fetcher<CreateNotificationChannelTopicMutation, CreateNotificationChannelTopicMutationVariables>(CreateNotificationChannelTopicDocument, variables)(),
    ...options
  }
    )};


useCreateNotificationChannelTopicMutation.fetcher = (variables: CreateNotificationChannelTopicMutationVariables) => fetcher<CreateNotificationChannelTopicMutation, CreateNotificationChannelTopicMutationVariables>(CreateNotificationChannelTopicDocument, variables);

export const UpdateNotificationChannelTopicDocument = new TypedDocumentString(`
    mutation UpdateNotificationChannelTopic($input: UpdateNotificationChannelTopicMutationInput!) {
  updateNotificationChannelTopic(input: $input) {
    notificationChannelTopic {
      id
    }
    errors {
      message
    }
  }
}
    `);

export const useUpdateNotificationChannelTopicMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateNotificationChannelTopicMutation, TError, UpdateNotificationChannelTopicMutationVariables, TContext>) => {
    
    return useMutation<UpdateNotificationChannelTopicMutation, TError, UpdateNotificationChannelTopicMutationVariables, TContext>(
      {
    mutationKey: ['UpdateNotificationChannelTopic'],
    mutationFn: (variables?: UpdateNotificationChannelTopicMutationVariables) => fetcher<UpdateNotificationChannelTopicMutation, UpdateNotificationChannelTopicMutationVariables>(UpdateNotificationChannelTopicDocument, variables)(),
    ...options
  }
    )};


useUpdateNotificationChannelTopicMutation.fetcher = (variables: UpdateNotificationChannelTopicMutationVariables) => fetcher<UpdateNotificationChannelTopicMutation, UpdateNotificationChannelTopicMutationVariables>(UpdateNotificationChannelTopicDocument, variables);

export const DeleteNotificationChannelTopicDocument = new TypedDocumentString(`
    mutation DeleteNotificationChannelTopic($input: DeleteNotificationChannelTopicMutationInput!) {
  deleteNotificationChannelTopic(input: $input) {
    success
    errors {
      message
    }
  }
}
    `);

export const useDeleteNotificationChannelTopicMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteNotificationChannelTopicMutation, TError, DeleteNotificationChannelTopicMutationVariables, TContext>) => {
    
    return useMutation<DeleteNotificationChannelTopicMutation, TError, DeleteNotificationChannelTopicMutationVariables, TContext>(
      {
    mutationKey: ['DeleteNotificationChannelTopic'],
    mutationFn: (variables?: DeleteNotificationChannelTopicMutationVariables) => fetcher<DeleteNotificationChannelTopicMutation, DeleteNotificationChannelTopicMutationVariables>(DeleteNotificationChannelTopicDocument, variables)(),
    ...options
  }
    )};


useDeleteNotificationChannelTopicMutation.fetcher = (variables: DeleteNotificationChannelTopicMutationVariables) => fetcher<DeleteNotificationChannelTopicMutation, DeleteNotificationChannelTopicMutationVariables>(DeleteNotificationChannelTopicDocument, variables);

export const SendTestNotificationDocument = new TypedDocumentString(`
    mutation SendTestNotification($input: SendTestNotificationMutationInput!) {
  sendTestNotification(input: $input) {
    success
    errors {
      message
    }
  }
}
    `);

export const useSendTestNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendTestNotificationMutation, TError, SendTestNotificationMutationVariables, TContext>) => {
    
    return useMutation<SendTestNotificationMutation, TError, SendTestNotificationMutationVariables, TContext>(
      {
    mutationKey: ['SendTestNotification'],
    mutationFn: (variables?: SendTestNotificationMutationVariables) => fetcher<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, variables)(),
    ...options
  }
    )};


useSendTestNotificationMutation.fetcher = (variables: SendTestNotificationMutationVariables) => fetcher<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, variables);
